import React from 'react';
import {Provider} from 'react-redux';

import {store} from './store';
import {Main} from './pages';

export default () => (
	<Provider store={store}>
		<Main/>
	</Provider>
);



// WEBPACK FOOTER //
// ./src/App.js